import { JwtTokens } from './jwt-tokens';
import { Observable } from 'rxjs';

export abstract class JwtServiceInterface {
  abstract blacklistRoutes: (string | RegExp)[];

  abstract getTokens(): Observable<JwtTokens | undefined>;
  abstract refreshToken(tokens: JwtTokens): Observable<JwtTokens | undefined>;
  abstract saveLocalTokens(tokens: JwtTokens): void;
  abstract logout(): void;
}
